// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtitle[data-v-5a8122ed] {\n  font-size: 1.2rem;\n  font-weight: 300;\n  line-height: 1.2;\n}\n.subtitle.centered[data-v-5a8122ed] {\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
